import { BookV1, NewBookV1 } from '@ilteducation/content-registry-types';
import { detailedDiff } from 'deep-object-diff';

export const getBookUpdates = (original: BookV1, updated: BookV1): Partial<BookV1> => {
  const objectDiff = detailedDiff(original, updated);

  const patch: Partial<BookV1> = {};

  // We assume that the properties marked by deep-object-diff ar properties of the book object
  // We assume no properties are removed. If an optional property is removed, it will be set to an empty value

  Object.keys(objectDiff.added).forEach((addedProp) => {
    const bookProperty = addedProp as keyof BookV1;

    // Unchanged optional properties show as undefined in the diff
    if (updated[bookProperty] !== undefined) {
      // @ts-ignore
      patch[bookProperty] = updated[bookProperty];
    }
  });

  Object.keys(objectDiff.updated).forEach((updatedProp) => {
    const bookProperty = updatedProp as keyof BookV1;

    // @ts-ignore
    patch[bookProperty] = updated[bookProperty];
  });

  return patch;
};

// Update request accepts NewBookV1 so we need to extract only the properties that are part of NewBookV1 from BookV1
export const bookV1ToNewBookV1 = (book: BookV1): NewBookV1 => {
  const { id, file, createdAt, lastUpdatedAt, ...rest } = book;
  return rest;
};

export const patchBookFields = (book: BookV1, patch: Partial<NewBookV1>): NewBookV1 => ({
  ...bookV1ToNewBookV1(book),
  ...patch,
});
